import { render, staticRenderFns } from "./provinceRoleList.vue?vue&type=template&id=c6c6b28a"
import script from "./provinceRoleList.vue?vue&type=script&lang=js"
export * from "./provinceRoleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c6b28a')) {
      api.createRecord('c6c6b28a', component.options)
    } else {
      api.reload('c6c6b28a', component.options)
    }
    module.hot.accept("./provinceRoleList.vue?vue&type=template&id=c6c6b28a", function () {
      api.rerender('c6c6b28a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/role/provinceRoleList.vue"
export default component.exports